export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/auth/Login'),
        props: true,
    },
];
